<template>
  <div id="app" title="心乡农：连接城乡生活">
    <div v-if="loginInfo.isLogin">
      <head-tab-bar></head-tab-bar>
      <page-header></page-header>
      <div id="content">
        <!--      <my-table></my-table>-->
        <!--      <my-date-show></my-date-show>-->
        <!--      <my-from></my-from>-->
        <router-view></router-view>
      </div>
      <div id="font">
        <a href="#">© 2020-现在 xsalo.cn，All rights reserved 粤ICP备17092164号</a>
      </div>
      <main-tab-bar></main-tab-bar>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import MyFrom from "./components/content/myFrom/MyFrom";
  import MyTable from "./components/content/myTable/MyTable";
  import PageHeader from "./components/content/pageHeader/PageHeader";
  import HeadTabBar from "./components/content/header/HeadTabBar";
  import MainTabBar from "./components/content/mainTabbar/MainTabBar";
  export default {
    components: {MyFrom, MyTable, PageHeader, HeadTabBar, MainTabBar},
    data(){
      return{
        loginInfo:null
      }
    },
    created() {
      document.title='心乡农：连接城乡生活';
      let isLogin = sessionStorage['isLogin'];
      if (isLogin=="false"){
        this.common.loginInfo.isLogin = false;
      }else if (isLogin=="true"){
        this.common.loginInfo.isLogin = true;
      }
      this.common.loginInfo.jwtToken = sessionStorage['jwtToken'];
      this.loginInfo = this.common.loginInfo;
    }
  }

</script>

<style>
  #app{
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  }
  body{
    width: 100%;
    padding: 0;
    margin: 0;
  }

  #content{
    background-color: #e4e5e6;
    min-height: calc(100vh - 201px - 50px);
    padding: 15px
  }

  #font a:link{
    color: #56bde1;
    text-decoration:none;
  }

  #font a:visited{
    color: #56bde1;
    text-decoration:none;
  }

  #font a:hover{
    color: #167495;
    text-decoration: underline;
  }

  #font a:active{
    color: #56bde1;
    text-decoration:none;
  }

  #font{
    position: relative;
    bottom: 0;
    left: 200px;
    background-color: #fff;
    height: 50px;
    line-height: 50px;
    font-size: 0.875rem;
    width: calc(100% - 200px - 20px);
    padding-left: 20px;
  }
</style>
